import * as React from "react";
import { Outlet } from "react-router-dom";
import type { AdminOrder } from "src/providers/order-provider";
import { OrdersList } from "./orders-list";

export type OrdersOutletContext = {
	orders: AdminOrder[];
	isLoading: boolean;
};

export function OrdersLayout() {
	const [orders, setOrders] = React.useState<AdminOrder[]>([]);
	const [totalCount, setTotalCount] = React.useState(0);
	const [isLoading, setIsLoading] = React.useState(true);

	return (
		<>
			<OrdersList
				orders={orders}
				totalCount={totalCount}
				isLoading={isLoading}
				setOrders={setOrders}
				setTotalCount={setTotalCount}
				setIsLoading={setIsLoading}
			/>
			<Outlet context={{ orders, isLoading }} />
		</>
	);
}
